import request from "../../utils/NetWorkUtil";

const getCarouselNews=async function getCarouselNews() {
    return request('/api/news', {
        method: 'GET',
        headers: {
            Accept: 'application/json,version=4'
        }
    });
}

// 获取企业简介的信息。
const getFirmIntro= async function getFirmIntro(){
    return request('/api/Config',{
        method: 'GET',
    })
}

export {
    getCarouselNews,
    getFirmIntro
};
